/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Fabien SERRA
 * @date        09/06/2022 11:44
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import hideOnScroll from 'hide-on-scroll';

export default class Navbar {

	static navbar       = '.navbar';
	static hidden_class = 'hidden';
	static sticky_class = 'sticky';

	constructor()
	{
		Navbar.manage_auto_hide();
		Navbar.manage_class_sticky();
		$( window ).on( 'scroll', () => {
			Navbar.manage_class_sticky();
		} );
	}

	static manage_auto_hide()
	{
		hideOnScroll( {
			navbarSelector: Navbar.navbar,
			hidingClass: Navbar.hidden_class
		} );
	}

	static manage_class_sticky()
	{
		if ( $( window ).scrollTop() > 100 ) {
			if ( !$( Navbar.navbar ).hasClass( Navbar.sticky_class ) ) {
				$( Navbar.navbar ).addClass( Navbar.sticky_class );
			}
		} else {
			$( Navbar.navbar ).removeClass( Navbar.sticky_class );
		}
	}
}
